import { EditorHelp } from '../../partials';
import { Namespace } from '../../../../../../../translation/namespace';
import { SONEditorConfig } from '../../types';

const keyboardIcon =
  '<svg width="22" height="22" viewBox="0 0 14 14">' +
  '<circle cx="1" cy="10.01" r="1" />' +
  '<circle cx="1" cy="6.9" r="1" />' +
  '<circle cx="1" cy="4.01" r="1" />' +
  '<circle cx="10.03" cy="6.9" r="1" />' +
  '<circle cx="10.03" cy="4.01" r="1" />' +
  '<circle cx="3.99" cy="6.9" r="1" />' +
  '<circle cx="3.99" cy="4.01" r="1" />' +
  '<circle cx="7.01" cy="6.88" r="1" />' +
  '<circle cx="7.01" cy="3.99" r="1" />' +
  '<circle cx="13" cy="10.01" r="1" />' +
  '<circle cx="13" cy="6.9" r="1" />' +
  '<circle cx="13" cy="4.01" r="1" />' +
  '<rect x="3" y="9.01" width="8" height="1.99" rx="1" />' +
  '</svg>';

export const SonHelpPlugin = (config?: SONEditorConfig) => ({
  title: `${Namespace.Editor}:keyboardHelp`,
  icon: 'son_help_keyboard_icon',
  name: 'son_help_plugin',
  Component: () => EditorHelp({ config }),
  addAdditionalIcon: {
    name: 'son_help_keyboard_icon',
    svg: keyboardIcon,
  },
});
